module.exports = __webpack_public_path__ + "img/company_dissolution-date.9906906d.svg";